// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.lf-simple-row-container[data-v-664d5938] {\n  border-radius: 8px;\n  border: 1px solid #ccd1e4;\n}\n[data-v-664d5938] .e-grid.grid-table .e-toolbar {\n  background-color: #fafafa;\n  margin: 12px 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
